import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { VisitCalendar } from "../components/VisitCalendar";
import { VisitHistory } from "../components/VisitHistory";

export function VisitsPage() {
  return (
    <div className="space-y-6">
      <Tabs defaultValue="calendar" className="space-y-6">
        <TabsList>
          <TabsTrigger value="calendar">Calendar</TabsTrigger>
          <TabsTrigger value="history">Visit History</TabsTrigger>
        </TabsList>

        <TabsContent value="calendar">
          <VisitCalendar />
        </TabsContent>

        <TabsContent value="history">
          <VisitHistory />
        </TabsContent>
      </Tabs>
    </div>
  );
}